/* eslint-disable no-param-reassign */
import { useContext, useEffect, useState } from 'react';

import { arrayToDict, makeRequest } from 'utils';
import { useContextProperties } from 'contexts/properties';
import Logger from '../../utils/logger';
import FirebaseContext from '../results/firebaseContext';
import { result as resultEndPoint } from '../../constants/api';
import { PATH, TYPES } from '../../envs/core';
import { customAcronym, customColor, getSite } from '../../constants';
import useMatchParties from './useMatchParties';
import { isPreEnv } from '../../core/constants';

const empty = {};
const emptyArr = [];

const mapParties = (partyFormats, site, old, electionPlace) => res => {
  let partyFormat = partyFormats[res.id];
  if (
    partyFormat &&
    partyFormat.region &&
    partyFormat.region !== electionPlace
  ) {
    partyFormat = Object.values(partyFormats).find(_party => {
      if (old) {
        return _party.previousIds === res.id && _party.region === electionPlace;
      }
      return _party.currentId === res.id && _party.region === electionPlace;
    });
  } else {
    partyFormat = partyFormats[res.id];
  }

  return {
    ...res,
    votesPercent: res.votesPercent
      ? parseFloat(res.votesPercent.toFixed(2))
      : 0,
    originalName: res.name,
    originalPartyAcronym: res.partyAcronym,
    originalPartyColor: res.originalName,

    partyAcronym:
      // !old && partyFormat
      //   ? customAcronym(partyFormat, site || getSite()) || res.partyAcronym
      //   : res.partyAcronym,
      partyFormat
        ? customAcronym(partyFormat, site || getSite()) || res.partyAcronym
        : res.partyAcronym,
    partyColor: partyFormat
      ? customColor(partyFormat, site || getSite()) || res.partyColor
      : res.partyColor
  };
};
export default function useResultProvider({
  active,
  year,
  type,
  subtype = 'SINGLE',
  electionNumber,
  placeId,
  electionPlace,
  onlyWinners = false,
  details = false,
  customPath,
  totals = false,
  site,
  allData,
  currentPartiesIds,
  communityData = false,
  isBackupTV = false
}) {
  const { params } = useContextProperties();
  const old = Number(year) !== params.elections.year;

  const [result, setResult] = useState({});

  const { app1, app2, app3, appBackup, firebase } = useContext(FirebaseContext);

  const matchParties = useMatchParties() || emptyArr;

  const getFirebaseData = (resultRefs, success, error) => {
    if (resultRefs.length > 0) {
      resultRefs[0]().on(
        'value',
        dataResult => {
          success(
            { resultRef: resultRefs[0], data: dataResult.val() },
            'Firebase',
            // eslint-disable-next-line no-underscore-dangle
            dataResult.ref.path.pieces_.join('/')
          );
        },
        _error => {
          console.log('QUITAMOS UN RESULT REFS', resultRefs.length);
          resultRefs.shift();
          getFirebaseData(resultRefs, success, error);
        }
      );
    } else {
      error(success);
    }
  };

  const callAmazon = success => {
    // si algun parametro es undefined no hacemos la llamada
    if (!year || !type || !electionNumber || !subtype) {
      return;
    }

    let amazonPath = `${resultEndPoint}/${year}/${type}/${subtype}/${electionNumber}/${
      totals ? 'C108/TOTALS' : placeId || 'C108/TOTALS'
    }`;

    if (type === 'GENERAL') {
      amazonPath = `${resultEndPoint}/${year}/${type}/${subtype}/${electionNumber}/${
        totals ? 'C108' : placeId || 'C108'
      }`;
    }
    Logger.log(
      'ResultProvider.callAmazon',
      `amazonPath: ${amazonPath} len${matchParties?.length}`
    );
    // TODO asiendo ñapitas grasias a back
    makeRequest(`${PATH}${amazonPath}`)
      // Axios.get(`${PATH}${amazonPath}`)
      .then(d => {
        success({ data: d }, 'Amazon', `${amazonPath}`);
        // success(d, 'Amazon', `${amazonPath}`);
      })
      .catch(err => {
        console.log('error', err);
      });
  };

  useEffect(() => {
    if (!matchParties?.length) {
      return setResult(empty);
    }

    if (communityData && details) {
      return setResult(empty);
    }

    const changeSubscribtion = () => {
      if (result.currentResultRef) {
        result.currentResultRef().off();
      }

      if (currentPartiesIds && !currentPartiesIds.length) {
        return setResult(empty);
      }

      const electionPlacePath =
        type === TYPES.REGIONAL ? `/${electionPlace}` : '';

      let firebasePath = customPath;
      if (!customPath) {
        if (!details) {
          if (type === 'GENERAL') {
            firebasePath = `${year}/${type}/${subtype}/${electionNumber}${
              totals ? '' : electionPlacePath
            }/${'C108/TOTALS'}/${placeId || ''}`;
          } else {
            firebasePath = `${year}/${type}/${subtype}/${electionNumber}${
              totals ? '' : electionPlacePath
            }/${totals ? 'C108/TOTALS' : !details ? 'TOTALS' : 'TOWNS'}/${
              placeId || ''
            }`;
          }
        } else if (type === 'GENERAL') {
          firebasePath = `${year}/${type}/${subtype}/${electionNumber}${electionPlacePath}/C108/TOWNS/${placeId}`;
        } else {
          firebasePath = `${year}/${type}/${subtype}/${electionNumber}${
            totals ? '' : electionPlacePath
          }/${totals ? 'C108/TOTALS' : !details ? 'TOTALS' : 'TOWNS'}/${
            placeId || ''
          }`;
        }
        if (type === 'MUNICIPAL' && placeId !== 'C108') {
          firebasePath = `${year}/${type}/${subtype}/${electionNumber}/C108/TOWNS/${placeId}`;
        }

        if (type === 'MUNICIPAL' && totals) {
          firebasePath = `${year}/${type}/${subtype}/${electionNumber}/C108/WINNERS`;
        }
        if (type === 'MUNICIPAL' && allData) {
          firebasePath = `/2023/MUNICIPAL/SINGLE/${electionNumber}/C108/TOTALS/C108`;
        }
        if (type === 'GENERAL' && (allData || totals)) {
          firebasePath = `/2019/GENERAL/${subtype}/${electionNumber}/C108/TOTALS/C108`;
        }
      }
      firebasePath = isBackupTV ? `data/${firebasePath}` : firebasePath;
      Logger.log(
        'ResultProvider',
        'changeSubscribtion',
        `| firebase path: ${firebasePath}`
      );

      if (firebasePath.includes('undefined')) {
        return;
      }
      const resultRef = () => firebase.database(app1).ref(firebasePath);
      const resultRef2 = () => firebase.database(app2).ref(firebasePath);
      const resultRef3 = () => firebase.database(app3).ref(firebasePath);
      const resultRefBackupTV = () =>
        firebase.database(appBackup).ref(firebasePath);

      const successFunction = (
        { data: dataResult, resultRef: currentResultRef },
        from,
        path
      ) => {
        if (dataResult) {
          if (
            type === 'MUNICIPAL' &&
            totals &&
            dataResult &&
            !dataResult.C108
          ) {
            dataResult = {
              C108: Object.keys(dataResult).map(d => ({
                ...dataResult[d],
                placeId: d
              }))
            };
          }

          if (matchParties?.length) {
            let partyFormats = [];

            partyFormats = arrayToDict(
              currentPartiesIds && currentPartiesIds.length
                ? matchParties.filter(a =>
                    currentPartiesIds.some(
                      oldParty => oldParty.id === a.currentId
                    )
                  )
                : matchParties,
              old ? 'previousIds' : 'currentId'
            );

            // esto es para todo menos el total
            if (dataResult.partiesResult) {
              dataResult.partiesResult = dataResult.partiesResult
                // .filter(result => result.votesPercent)
                .map(mapParties(partyFormats, site, old, electionPlace));
              dataResult.partiesWinners = dataResult.partiesWinners
                ? dataResult.partiesWinners.map(res => {
                    const partyFormat = partyFormats[res.id];
                    return {
                      ...res,

                      partyAcronym: partyFormat
                        ? customAcronym(partyFormat, site || getSite())
                        : res.partyAcronym,
                      partyColor: partyFormat
                        ? customColor(partyFormat, site || getSite())
                        : res.partyColor
                    };
                  })
                : [];
            } else {
              dataResult = Object.keys(dataResult).reduce((tot, key) => {
                const regionArray = dataResult[key];
                if (regionArray.map) {
                  const regionArrayMapped = regionArray.map(provinceResult => {
                    const partiesResult =
                      provinceResult.partiesResult?.map(
                        mapParties(partyFormats, site, old, electionPlace)
                      ) || [];
                    const partyWinners =
                      provinceResult.partiesWinners?.map(
                        mapParties(partyFormats, site, old, electionPlace)
                      ) || [];
                    const id =
                      provinceResult.id ||
                      regionArray.find(
                        r => r.partyAcronym === provinceResult.partyAcronym
                      )?.id;
                    const partyWinner = partyFormats[id];

                    return {
                      ...provinceResult,
                      partiesResult,
                      partyWinners,
                      ...partyWinner
                    };
                  });

                  return {
                    ...tot,
                    [key]: regionArrayMapped
                  };
                }

                return {
                  ...tot,
                  [key]: regionArray
                };
              }, {});
            }
          }

          if (totals) {
            return setResult(dataResult);
          }
          dataResult.abstentionPercent = dataResult.abstentionPercent
            ? Number(dataResult.abstentionPercent).toFixed(2)
            : 0;
          dataResult.currentCountPercent = dataResult.currentCountPercent
            ? Number(dataResult.currentCountPercent).toFixed(2)
            : 0;
          dataResult.invalidPercent = dataResult.invalidPercent
            ? Number(dataResult.invalidPercent).toFixed(2)
            : 0;
          dataResult.participationPercent = dataResult.participationPercent
            ? Number(dataResult.participationPercent).toFixed(2)
            : 0;
          dataResult.whitePercent = dataResult.whitePercent
            ? Number(dataResult.whitePercent).toFixed(2)
            : 0;

          // eslint-disable-next-line prefer-destructuring
          dataResult.updateDate = new Date(dataResult.updateDate)
            .toTimeString()
            .split(' ')[0];
          dataResult.updateDate =
            dataResult.updateDate !== 'Invalid'
              ? dataResult.updateDate
              : '00:00';
        }
        if (onlyWinners) {
          setResult(dataResult.partiesWinners);
        } else {
          setResult(
            dataResult
              ? { ...dataResult, currentResultRef }
              : { currentResultRef }
          );
        }

        Logger.log(
          `ResultProvider.successFunction from ${from}`,
          `Obitene resultados ${path}`
        );
        console.log(
          '#### ResultProvider',
          {
            params: {
              active,
              year,
              type,
              subtype,
              electionNumber,
              placeId,
              electionPlace,
              onlyWinners,
              details,
              customPath,
              totals,
              site,
              allData,
              old,
              currentPartiesIds
            }
          },
          `| firebase path: ${firebasePath}`,
          dataResult
        );
      };

      Logger.log(
        'ResultProvider.changeSubscribtion',
        `pide a : ${active ? 'firebase' : 'amazon'}`
      );
      if (active) {
        getFirebaseData(
          // isPreEnv ? [resultRef3] : isBackupTV ? [appBackup] : [resultRef, resultRef2, resultRef3],
          isBackupTV
            ? [resultRefBackupTV]
            : isPreEnv
            ? [resultRef3]
            : [resultRef, resultRef2, resultRef3],
          successFunction,
          callAmazon
        );
      } else {
        callAmazon(successFunction);
      }
    };
    if (
      (subtype === 'INSULAR' || subtype === 'AUTONOMIC') &&
      (!['R05', '35', '38'].includes(placeId) || electionPlace !== 'R05')
      // (!['R05', '35', '38'].includes(placeId) || electionPlace !== 'R05') &&
      // !details &&
      // electionPlace !== 'R05'
    ) {
      setResult(empty);
      return;
    }

    if (active === undefined && !customPath) {
      Logger.log('ResultProvider.useEffect', 'no llama a origen');
      setResult({});
      return;
    }

    changeSubscribtion();

    return () => result.currentResultRef && result.currentResultRef().off();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    active,
    type,
    subtype,
    year,
    electionNumber,
    placeId,
    matchParties,
    currentPartiesIds
  ]);

  // return !matchParties ? { result: null } : { result };
  return { result };
}
